import React from 'react';
import { useRouter } from 'next/navigation';
import { UserData } from '@/app/types/userData';

interface ActionButtonProps {
  selectedAction: string;
  isPending: boolean;
  isConfirming: boolean;
  isConfirmed?: boolean;
  txHash?: string;
  error?: boolean;
  buttonTxt: string;
  handleSubmit: () => void;
  handleButtonClick: () => void;
  handleViewTx: () => void;
  userData: UserData;
  delegateAddress?: string;
}

const isValidAddress = (address: string) => {
  return /^0x[a-fA-F0-9]{40}$/.test(address);
};

const ActionButton: React.FC<ActionButtonProps> = ({
  selectedAction,
  isPending,
  isConfirming,
  isConfirmed,
  txHash,
  error,
  buttonTxt,
  handleSubmit,
  handleButtonClick,
  handleViewTx,
  delegateAddress = '',
}) => {
  const router = useRouter();

  const isDisabled =
    isPending ||
    isConfirming ||
    !selectedAction ||
    (selectedAction === 'manualDelegation' && !isValidAddress(delegateAddress));

  const handleNavigation = () => {
    if (selectedAction === 'find') {
      router.push('/karratco/view/seekingdelegations');
    } else if (selectedAction === 'ask') {
      router.push('/karratco/submit/delegationstatement');
    } else if (selectedAction === 'view') {
      router.push('/karratco/view/seekingdelegations');
    } else if (buttonTxt === 'View on BlockExplorer') {
      handleViewTx();
    } else if (
      (buttonTxt === 'Revoke' && selectedAction === 'revoke') ||
      buttonTxt === 'Delegate' ||
      (buttonTxt === 'Self Delegate' && selectedAction === 'selfDelegate') ||
      selectedAction === 'delegate'
    ) {
      handleButtonClick();
    } else {
      handleSubmit();
    }
  };

  return (
    <button
      className={`flex justify-center min-w-full py-2 px-4 border rounded-md text-btntext bg-link border-link text-sm max-h-[40px] mt-2 ${
        isDisabled
          ? 'cursor-not-allowed hover:bg-link border-link text-btntext'
          : 'cursor-pointer hover:bg-hover hover:border-hover text-btntexthover'
      }`}
      onClick={handleNavigation}
      disabled={isDisabled}
    >
      {buttonTxt}
    </button>
  );
};

export default ActionButton;
